import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBloggerComponent } from './simple-icons-blogger.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBloggerComponent ],
    exports:      [ SimpleIconsBloggerComponent ],
    bootstrap:    []
})
export class SimpleIconsBloggerModule {}
